export enum AvailableType {
  ALL = 'ALL',
  TRUE = 'TRUE',
  FALSE = 'FALSE'
}

export enum OrderType {
  DESC = 'DESC',
  ASC = 'ASC'
}

export enum SearchSelectType {
  all = 'all',
  email = 'email',
  name = 'name',
  mobile = 'mobile'
}

export enum SearchResearchSelectType {
  all = 'all',
  id = 'id',
  name = 'name',
  mobile = 'mobile'
}

export enum UserRestrictType {
  전체 = '전체',
  활동회원 = '활동회원',
  정지회원 = '정지회원',
  휴먼회원 = '휴먼회원',
  탈퇴회원 = '탈퇴회원'
}

export enum UserSexType {
  MALE = 'MALE',
  FEMALE = 'FEMALE'
}

export enum UserFindManyEnum {
  id = 'id',
  name = 'name',
  email = 'email',
  mobile = 'mobile',
  mobile_confirm = 'mobile_confirm',
  created_at = 'created_at',
  restrict = 'restrict',
  sex = 'sex',
  birthday = 'birthday'
}

export enum TermsLangEnum {
  korean = 'korean'
}

export enum TermsTypeEnum {
  user = 'user'
}

export enum TermsOrderColumnEnum {
  id = 'id',
  type = 'type',
  title = 'title',
  body = 'body',
  langage = 'langage',
  available = 'available',
  essential = 'essential',
  created_at = 'created_at',
  updated_at = 'updated_at'
}

export enum MeasurePurposeEnum {
  건강관리 = '건강관리',
  재활 = '재활',
  연구참여 = '연구참여',
  운동관리 = '운동관리',
  기타 = '기타'
}

export enum FindResearchOrderColumn {
  id = 'id',
  email = 'email',
  mobile = 'mobile',
  created_at = 'created_at'
}

export enum ResearchUserFindManyEnum {
  id = 'id',
  name = 'name',
  mobile = 'mobile',
  created_at = 'created_at',
  sex = 'sex',
  birthday = 'birthday'
}
